export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Latin2-88a55c40cca383f1bfcc563ccb2b6df4.woff";